var _path, _path2, _rect;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRightAlignment(_ref, svgRef) {
  var {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.7181 3.90544H28.7181C29.0717 3.90544 29.4109 3.76496 29.6609 3.51491C29.911 3.26486 30.0514 2.92572 30.0514 2.5721C30.0514 2.21848 29.911 1.87934 29.6609 1.62929C29.4109 1.37925 29.0717 1.23877 28.7181 1.23877H4.7181C4.36448 1.23877 4.02534 1.37925 3.77529 1.62929C3.52524 1.87934 3.38477 2.21848 3.38477 2.5721C3.38477 2.92572 3.52524 3.26486 3.77529 3.51491C4.02534 3.76496 4.36448 3.90544 4.7181 3.90544Z",
    fill: "#CCA3CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28955 30.7609H28.147C28.6522 30.7609 29.1366 30.6204 29.4939 30.3704C29.8511 30.1203 30.0518 29.7812 30.0518 29.4276C30.0518 29.0739 29.8511 28.7348 29.4939 28.4848C29.1366 28.2347 28.6522 28.0942 28.147 28.0942H5.28955C4.78437 28.0942 4.29988 28.2347 3.94266 28.4848C3.58545 28.7348 3.38477 29.0739 3.38477 29.4276C3.38477 29.7812 3.58545 30.1203 3.94266 30.3704C4.29988 30.6204 4.78437 30.7609 5.28955 30.7609Z",
    fill: "#CCA3CF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.8633,
    y: 7.90625,
    width: 16.1885,
    height: 16.1885,
    rx: 2,
    fill: "#CCA3CF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightAlignment);
export default __webpack_public_path__ + "static/media/rightAlignment.bd80a2ef256569c28d3baf22e34bf975.svg";
export { ForwardRef as ReactComponent };